<template>
  <div class="site-page visa-page">
    <section class="sub-page-banner visa-banner">
      <div class="site-container">
        <h1>签证移民</h1>
      </div>
    </section>

    <div class="site-container visa-content">
      <section class="visa-section">
        <h2 class="section-title">新西兰项目</h2>
        <div class="visa-grid">
          <article class="visa-card" v-for="item in visaItems" :key="item.id" @click="viewDetail(item)">
            <h3>{{ item.name }}</h3>
            <p><span>办理周期：</span>{{ item.period }}</p>
            <p><span>投资金额：</span>{{ item.amount }}</p>
            <p><span>英文要求：</span>{{ item.english }}</p>
            <button type="button">查看详情</button>
          </article>
        </div>
      </section>

      <section class="case-section">
        <header class="case-head">
          <h2 class="section-title">最新成功案例</h2>
          <button type="button" class="more-btn" @click="$router.push({ path: '/news', query: { tab: 'cases' } })">查看更多 ></button>
        </header>
        <div class="case-grid">
          <article class="case-card" v-for="item in cases" :key="item.id" @click="viewCase(item)">
            <div class="case-cover"><img :src="item.cover" alt=""></div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
            <div class="meta">
              <span>{{ item.tag }}</span>
              <span>{{ item.date }}</span>
            </div>
          </article>
        </div>
      </section>
    </div>

    <div class="float-tools">
      <button class="tool-btn" type="button" @click="scrollTop">
        <img src="@/assets/imgs/ysgj_006@2x.png" alt="顶部">
      </button>
      <button class="tool-btn" type="button" @click="showMessage">
        <img src="@/assets/imgs/ysgj_007@2x.png" alt="咨询">
      </button>
    </div>
  </div>
</template>

<script>
import {
  buildNewsDetailPath,
  buildProjectDetailPath,
} from '@/data/siteData'
import { getNewsList, getProjectList } from '@/api'

export default {
  name: 'Visa',
  data() {
    return {
      visaItems: [],
      cases: [],
    }
  },
  created() {
    this.fetchPageData()
  },
  methods: {
    async fetchPageData() {
      await Promise.all([
        this.fetchProjects(),
        this.fetchCases(),
      ])
    },
    async fetchProjects() {
      try {
        const data = await getProjectList()
        this.visaItems = Array.isArray(data.list) ? data.list : []
      } catch (error) {
        this.visaItems = []
      }
    },
    async fetchCases() {
      try {
        const data = await getNewsList({
          type: 'cases',
          limit: 8,
        })
        this.cases = Array.isArray(data.list) ? data.list : []
      } catch (error) {
        this.cases = []
      }
    },
    viewDetail(item) {
      this.$router.push(buildProjectDetailPath(item.id))
    },
    viewCase(item) {
      this.$router.push(buildNewsDetailPath(item.id))
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    showMessage() {
      this.$Message.info('在线咨询功能开发中...')
    },
  },
}
</script>

<style scoped>
.visa-banner {
  background-image: url('~@/assets/imgs/ysgj_040@2x.png');
  background-position: center;
  background-size: cover;
}

.visa-content {
  position: relative;
  z-index: 4;
  padding-top: 26px;
}

.visa-section,
.case-section {
  padding: 24px 0;
}

.case-section {
  margin-top: 16px;
}

.visa-grid {
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.visa-card {
  background: #fff;
  border: 1px solid var(--site-border);
  border-radius: 10px;
  padding: 18px 28px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.visa-card:hover {
  border-color: #c8d9ee;
  box-shadow: 0 6px 16px rgba(20, 87, 165, 0.09);
  transform: translateY(-2px);
}

.visa-card h3 {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
  color: #38465d;
  margin-bottom: 10px;
}

.visa-card p {
  font-size: 14px;
  color: #7a8595;
  line-height: 1.6;
}

.visa-card p span {
  color: #9ba4b2;
}

.visa-card button {
  margin-top: 14px;
  width: 100%;
  border: none;
  height: 36px;
  border-radius: 18px;
  background: var(--site-blue);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.visa-card button:hover {
  background: var(--site-blue-dark);
}

.case-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.more-btn {
  height: 26px;
  padding: 0 12px;
  border-radius: 13px;
  border: 1px solid #d8e4f1;
  background: #f8fbff;
  color: #6f7f95;
  font-size: 12px;
  cursor: pointer;
}

.more-btn:hover {
  color: var(--site-blue);
}

.case-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.case-card {
  background: #fff;
  border: 1px solid var(--site-border);
  border-radius: 10px;
  overflow: hidden;
  padding: 0 0 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.case-card:hover {
  box-shadow: 0 6px 16px rgba(20, 87, 165, 0.09);
  transform: translateY(-2px);
}

.case-cover {
  height: 180px;
  overflow: hidden;
  background: #e8f0f8;
}

.case-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.case-card h3 {
  margin-top: 10px;
  padding: 0 10px;
  font-size: 13px;
  color: #47556b;
  line-height: 1.45;
  height: 37px;
  overflow: hidden;
}

.case-card p {
  margin-top: 6px;
  padding: 0 10px;
  font-size: 12px;
  color: #97a0ae;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.case-card .meta {
  margin-top: 8px;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #a2abb8;
}

.float-tools .tool-btn {
  width: 46px;
  height: 46px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: none;
  box-shadow: none;
  border: none;
}

.float-tools .tool-btn img {
  width: 46px;
  height: 46px;
}
</style>
